/**
 * Collector for advisory messages that must survive `--output json`.
 *
 * Commands render progress through a `log` closure that is a NO-OP in json mode.
 * That is right for progress and wrong for advisories: it means the automated
 * install path - the one with nobody watching - is the only path that sees
 * nothing. Anything a human would want to act on goes here instead, so it lands
 * on the JSON result and reaches the installer's status doc.
 *
 * ONE unlevelled channel, deliberately. A severity axis with a single member is
 * noise; add the field when a producer actually needs to distinguish.
 */
export interface WarningSink {
  add(msg: string): void;
  list(): string[];
}

export function makeWarningSink(echo?: (msg: string) => void): WarningSink {
  const items: string[] = [];
  return {
    add(msg: string): void { items.push(msg); echo?.(msg); },
    list(): string[] { return items.slice(); },
  };
}
